import React from 'react'

const test = () => {
    const calculateDriverStats = (rides) => {
        // Funkce pro výpočet času cesty tam a zpět
        const calculateRoundTripTime = (distance) => {
          return (distance / 1000) * 1.4; // Převedeme metry na kilometry a spočítáme tam a zpět
        };
    
        const addMinutesToDate = (date, minutes) => {

          const result = new Date(date);
          result.setMinutes(result.getMinutes() + minutes);
          return result;
        };
    
        // Funkce pro formátování data na požadovaný formát "HH:MM DD.MM.YYYY"
        const formatDate = (date) => {
          const d = new Date(date);
          const hours = String(d.getHours()).padStart(2, '0');
          const minutes = String(d.getMinutes()).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          const month = String(d.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexované od 0
          const year = d.getFullYear();
          return `${hours}:${minutes} ${day}.${month}.${year}`;
        };
    
        // Vyfiltrujeme pouze jízdy se statusem 2 nebo 3
        const filteredRides = rides.filter(
          (ride) => Number(ride.status) === 2 || Number(ride.status) === 3
        );
    
        // Pro každého řidiče uchováme pouze poslední jízdu
        const driverStats = {};
    
        filteredRides.forEach((ride) => {
          const { driver, tripDistance, destinationTime } = ride;
    
          // Pokud nemáme statistiku pro řidiče, inicializujeme
          if (!driverStats[driver]) {
            driverStats[driver] = {
              count: 0,
              totalRoundTripTime: 0,
              latestRide: null, // Zde uchováváme poslední jízdu
              completionTime: null,
            };
          }
    
          // Přidáme jízdu do počtu a spočítáme celkový čas tam a zpět, pokud je to poslední jízda
          if (
            !driverStats[driver].latestRide ||
            new Date(destinationTime) > new Date(driverStats[driver].latestRide.destinationTime)
          ) {
            driverStats[driver].count = 1; // Ponecháme pouze poslední jízdu, takže vždy bude 1
            driverStats[driver].totalRoundTripTime = calculateRoundTripTime(tripDistance);
            driverStats[driver].latestRide = ride; // Aktualizujeme poslední jízdu
          }
        });
    
        // Spočítáme čas, kdy bude mít řidič hotovo, a převedeme na požadovaný formát
        Object.keys(driverStats).forEach((driver) => {
          const latestRideTime = driverStats[driver].latestRide.destinationTime;
          const totalRoundTripTime = driverStats[driver].totalRoundTripTime; // Převedeme čas do minut
    
          // Přičteme celkový čas tam a zpět (v minutách) k poslední jízdě
          const completionDate = addMinutesToDate(latestRideTime, totalRoundTripTime);
    
          // Převedeme completionDate na formát "HH:MM DD.MM.YYYY"
          driverStats[driver].completionTime = formatDate(completionDate);
        });
    
        return driverStats;
      };
    
      // Testovací data (nahraď skutečnými daty)
      const rides = [
        { id: 3428, driver: 1, status: 3, tripDistance: 2000, destinationTime: '2024-10-04 15:40:27' },
        { id: 3428, driver: 1, status: 3, tripDistance: 10000, destinationTime: '2024-10-04 14:55:27' },
    
        { id: 3431, driver: 2, status: 3, tripDistance: 90000, destinationTime: '2024-10-04 16:00:00' }, // Tento řidič bude mít pouze poslední jízdu
      ];
    
      // Zavolání funkce
      const stats = calculateDriverStats(rides);
      console.log(stats[1]);
      console.log(stats[2]);
    
      
      

      
  return (
    <div>
      
    </div>
  )
}

export default test
